import React from 'react';
import './styles.css';
import {
    divisa, 
    factura, 
    sat, 
    xml
} from './CFDI/imagenesCFDI'

export default function DescripcionCFDI(props){


    return(<>
     <div className='contenedorDescripcionCFDI'>
        <div className='contenedorGeneralDescripcionCFDI'>
        <div className='contenedorTituloDescripcionCFDI'>
            <p>¿POR QUÉ ADQUIRIR T&T CFDI?</p>
        </div>
        <div className='caracteristicasDescripcionCFDI'>
            <div className='contenedorConjunto'>
                <div className='contenedorImagenDescripcionCFDI'>
                    <img src={factura}/>
                </div>
                <div className='contenedorDescripcionCFDIImagen'>
                    <p>Diseñador de <br/> facturas integrado</p>
                </div>
            </div>

            <div className='contenedorConjunto'>
                <div className='contenedorImagenDescripcionCFDI'>
                    <img src={sat}/>
                </div>
                <div className='contenedorDescripcionCFDIImagen'>
                    <p>Cancelación<br/> directa en el SAT</p>
                </div>
            </div>

            <div className='contenedorConjunto'>
                <div className='contenedorImagenDescripcionCFDI'>
                    <img src={xml}/>
                </div>
                <div className='contenedorDescripcionCFDIImagen'>
                    <p>Carga y descarga <br/> de XML</p>
                </div>
            </div>

            <div className='contenedorConjunto'>
                <div className='contenedorImagenDescripcionCFDI'>
                    <img src={divisa}/>
                </div>
                <div className='contenedorDescripcionCFDIImagen'>
                    <p>Manejo <br/> de divisas</p>
                </div>
            </div>
        </div>
    </div>
</div>
    </>)
}